import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { AssetTypeService } from '@app/services/asset-type.service';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Subject, switchMap } from 'rxjs';
import { PrTangibleFormBuilder } from './ea-tangible-form.builder';

@Component({
    selector: 'ea-tangible-form',
    templateUrl: './ea-tangible-form.component.html',
    styleUrls: ['./ea-tangible-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaTangibleFormComponent),
        },
    ],
    standalone: false
})
export class EaTangibleFormComponent
  extends PrTangibleFormBuilder
  implements OnInit
{
  users: any[];
  references: any;
  groupes: any[];
  sources: any[];
  managers: any[];
  tangibleCategories: any[] = [
    { id: 'CRYPTO', label: 'Crypto-monnaie' },
    {
      id: 'BOND',
      label: 'Fonds obligataires',
    },
    { id: 'FOREST', label: 'Forêt' },
    {
      id: 'EXISTING_HOUSING',
      label: 'Immobilier ancien nu',
    },
    {
      id: 'JEWELLERY',
      label: 'Montre / Bijou',
    },
    { id: 'NFT', label: 'NFT' },
    {
      id: 'COLLECTION',
      label: 'Objet de collection',
    },
    {
      id: 'PIECE_OF_ART',
      label: "Œuvre d'art",
    },
    { id: 'OPCI', label: 'OPCI' },
    { id: 'GOLD', label: 'Or physique' },
    { id: 'SOLAR', label: 'Solaire' },
    {
      id: 'AGRICULTURAL_LAND',
      label: 'Terre agricole',
    },
    { id: 'VIGNOBLE', label: 'Vignoble' },
    { id: 'WINE', label: 'Vin' },
  ];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);
  noTransition = true;

  products = this.assetTypeService.getTangibleAssetTypeOptionsSorted();

  constructor(
    protected formConstructor: PrFormConstructor,
    protected assetTypeService: AssetTypeService,
    private userDao: UserDao,
    private assetDao: AssetDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.assetDao.getReferences(),
      this.assetDao.getProviderByType('TANGIBLE'),
    ]).subscribe(([users, references, managers]) => {
      this.users = users;
      this.references = references;
      this.sources = references[0];
      this.managers = managers;
      this.setDefaultValue();

      const specificType = this.entity.tangibleCategory || this.entity.type;
      if (this.entity.id || (specificType && specificType !== 'TANGIBLE')) {
        this.selectProductType(specificType);
      }

      // Enable transitions after initial render
      setTimeout(() => {
        this.noTransition = false;
      }, 100);
    });
  }

  setDefaultValue() {
    if (this.entity.owners && this.entity.owners.length)
      this.form.get('owners').setValue(this.buildInitialOwners(this.entity));
  }

  get title() {
    return this.generateTitle("Modifier l'actif", 'Ajout d’un actif tangible');
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return `${editTitle} “${this.entity.label}”`;
  }

  selectProductType(productType) {
    this.form.controls.productType.setValue(productType);
    this.form.controls.tangibleCategory.setValue(productType);
    this.form.updateValueAndValidity();
  }

  onSubmit() {
    this.displayErrors();
    console.log({ form: this.form });

    this.selectErrorInput();

    if (this.form.invalid) {
      this.changeTab.next('FIRST');
      return;
    }

    //Fetch every form controls value
    let formDTOExtraction = this.extract();
    this.prFormService.loading();
    this.assetDao
      .proposeManagerProvider(formDTOExtraction, this.managers)
      .pipe(switchMap(() => this.assetDao.saveAssets(formDTOExtraction)))
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  onCancel() {
    this.prFormService.close();
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }
}
